
import React, { Component } from 'react';
import { connect } from 'react-redux'

import SelectComponent from './SelectComponent';

var translator = require('../../utils/translator/translator');
var printSettingsUtils = require('../../utils/domain/settings/printSettingsUtils');
var constants = require('../../utils/domain/constants');
var rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry');
var logger = require('../../utils/logger/logger');

class PrintSettingsView extends Component 
{
    render()
    {
        var receiptPrinterComponent = null;
        if (this.props.cachedData.loadedPrinters == null)
        {
            this.loadPrinters();
        }
        else
        {
            receiptPrinterComponent = <div>
                                            <SelectComponent
                                                getCaption={()=>{return translator.getLabel("receipt_printer")}}
                                                getHints={()=>{return translator.getLabel("choose_receipt_printer_for_this_terminal")}}
                                                onSelectionChanged={(option) =>
                                                {
                                                    if (option == null)
                                                        printSettingsUtils.setReceiptPrinter(null);
                                                    else
                                                        printSettingsUtils.setReceiptPrinter(option.value);
                                                }}
                                                options={this.props.cachedData.loadedPrinters}
                                                selectedValue={printSettingsUtils.getReceiptPrinter()}
                                                valueFieldName="value"
                                                displayFieldName="label"
                                                isClearable={true}/>
                                        </div>
        }

        return <div>
                    {receiptPrinterComponent}
                </div>
    }

    loadPrinters()
    {
        const resourceUrl = `${rmsApiProxyRetry.getOrgContextToUrl()}/terminals/printers/receipt`;
        rmsApiProxyRetry.get(resourceUrl)
                .then(printers =>
                {
                    var loadedPrinters = [];
                    printers.forEach(p =>
                        {
                            var url = `${p.url}`;
                            var option = {};
                            option.value = url;
                            option.label = url;
                            loadedPrinters.push(option);
                        })

                    this.props.cachedData.loadedPrinters = loadedPrinters;
                    this.setState({});
                }, 
                error =>
                {
                    this.props.cachedData.loadedPrinters = null;
                    logger.error(`Error occurred while loading printers: ${error}`, null, error);
                })
    }
}
const mapStateToProps = state => 
{
    return { 
                settingsChangedTimeStamp: state.settingsChangedTimeStamp,
           }
}

export default connect(mapStateToProps)(PrintSettingsView)
